export default __webpack_public_path__ + "static/media/cup.42be8e64.svg";